<script>
       import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>
<div class="main-div">

    <div class="left-div">
        <p class="text1">STORYTELLERS & Opus</p>
        <p class="text2">
            FANFICTION
            <br />
            WRITERS
        </p>
        <p class="text3">
            Whether you are particular about how it should have ended or disagree on how little action was given to your favorite character in a series, you don’t idly sit, you alter, extend and add depth to your favorite story and characters.         
        </p>

        <p class="text4">
            We’re building a platform that makes producing movies and games just as much a collaborative process for everyone as fanfiction writing is. More importantly, the derivatives are just as real as the original. Fix that ending, join our governing council now!

        </p>
        <div style="margin-top:5vh;">
            <DesktopButton2 
                state = "StoryTeller"
                text1="Join Storytellers Governance Council"
                text2="(Fanfiction Seat)"
                width = '31.611vh'
                AnimationColor = #A53BD6
                BorderColorAfter = '0.0052vw solid #A53BD6'
            />
        </div>
        <div class="scroll">
            <div class="imageWrraper">
                <img src="/images/createmain/arrow.svg" alt="arrow" width="100%" height="100%">
            </div>
            <div>
                <p>Scroll / Drag</p>
            </div>
            
        </div>
    </div>
    <div class="right-div">
    </div>
</div>
<style>

.main-div{
    display: flex;
    height: 100vh;
    position: relative;

}

.left-div{
    width: 46.574vh;
    padding-left: 16.204vh ;
}
.right-div{
    width: 52.037vh;
    background-image: url('/images/createmain/section5.png');
        background-size: cover;
        background-position: center;
        background-color: black;
}
p {
        font-family: "Orbitron";
        margin: 0;
    }
    .text1 {
        font-size: 1.296vh;
        font-weight: 400;
        padding-top: 24.352vh ;
    }
    .text2{
        color: #A53BD6;
        font-size: 5.556vh ;
        line-height: 5.556vh;
        font-weight: 800;
        margin-top: 1.481vh;
    }
    .text3{
        font-size: 1.296vh;
        font-weight: 400;
        width: 37.037vh;
        margin-top:6.204vh ;
        line-height: 1.815vh;
        letter-spacing: 0.05vw;
        margin-top: 6.204vh;
    }
    .text4{
        font-size: 1.296vh;
        width: 39.722vh;
        font-weight: 700;
        line-height: 2.043vh;
        letter-spacing: 0.1vh;
        margin-top: 3.519vh;
    }
    .scroll{
        position: absolute;
        color: rgb(0, 0, 0);
        display: flex;
        justify-content: space-between;
        align-items: center;
        float: right;
        top: 93.796vh;
        left: 18.556vh;
    }
    .scroll p{
        font-family: 'Orbitron';
        font-style: normal;
        font-weight: 700;
        font-size: 1.667vh;
    }
    .scroll .imageWrraper{
        width: 6.574vh;
        height: fit-content;
        margin-right: 2.593vh;
    }
</style>